const methods =  [
	{
		title: 'AdmUnit1Request',
		decription: 'Возвращает список административно-территориальных единиц первого уровня',
		decription_en: 'Returns the list of administrative units of the first level',
		standart: true,
		errorResponse: 2,
		id: 'AdmUnit1'
	},
	{
		title: 'AdmUnit2Request',
		decription: 'Возвращает список административно-территориальных единиц второго уровня',
		decription_en: 'Returns the list of administrative units of the second level',
		standart: true,
		errorResponse: 2,
		id: 'AdmUnit2'
	},
	{
		title: 'BathLocationRequest',
		decription: 'Возвращает список возможных расположений санузла',
		decription_en: 'Returns the list of bath locations',
		standart: true,
		errorResponse: 2,
		id: 'BathLocation'
	},
	{
		title: 'BedTypesRequest',
		decription: 'Возвращает список кроватей',
		decription_en: 'Returns the list of beds',
		standart: true,
		errorResponse: 2,
		id: 'BedTypes'
	},
	{
		title: 'BuyerImplantRequest',
		decription: 'Работа с покупателями для документооборота',
		decription_en: 'Buyers for workflow',
		standart: false,
		errorResponse: 1,
		id: 'BuyerImplant',
		warning: 'Устарело! Больше не используется!',
		warning_en: 'Deprecated!',
		old: 2,
	},
	{
		title: 'CitizenshipRequest',
		decription: 'Возвращает список гражданств гостей',
		decription_en: 'Returns the list of citizenships',
		standart: true,
		errorResponse: 2,
		id: 'Citizenship'
	},
	{
		title: 'CitizenshipListRequest',
		decription: 'Возвращает список гражданств гостей',
		decription_en: 'Returns the list of citizenships',
		standart: false,
		id: 'CitizenshipList',
		warning: 'Устарело! Используйте Citizenship!',
		warning_en: 'Deprecated! Use Citizenship!',
		old: 1,
	},
	{
		title: 'CityDescriptionRequest',
		decription: 'Возвращает подробную информацию о конкретном городе',
		decription_en: 'Returns the detailed description of the selected city',
		standart: false,
		id: 'CityDescription',
		warning: 'Устарело! Используйте City!',
		warning_en: 'Deprecated! Use City!',
		old: 1,
	},
	{
		title: 'CityListRequest',
		decription: 'Возвращает список городов, в которых расположены предлагаемые к продаже гостиницы',
		decription_en: 'Returns the list of cities where sells hotels',
		standart: false,
		id: 'CityList',
		warning: 'Устарело! Используйте City!',
		warning_en: 'Deprecated! Use City!',
		old: 1,
	},
	{
		title: 'CityRequest',
		decription: 'Возвращает подробную информацию о городе и список городов',
		decription_en: 'Returns detailed information about city and cities list',
		standart: false,
		errorResponse: 1,
		id: 'City'
	},
	{
		title: 'ClientCategoryListRequest',
		decription: 'Возвращает список категорий гостей',
		decription_en: 'Returns the list of client categories',
		standart: false,
		errorResponse: 1,
		id: 'ClientCategoryList',
		old: 1
	},
	{
		title: 'CountryDescriptionRequest',
		decription: 'Возвращает подробную информацию о конкретной стране',
		decription_en: 'Returns the detailed description of the selected country',
		standart: false,
		id: 'CountryDescription',
		warning: 'Устарело! Используйте Country!',
		warning_en: 'Deprecated! Use Country!',
		old: 1,
	},
	{
		title: 'CountryListRequest',
		decription: 'Возвращает список стран, в которых расположены предлагаемые к продаже	гостиницы.',
		decription_en: 'Returns the list of countries where sells hotels',
		standart: false,
		errorResponse: 1,
		id: 'CountryList',
		warning: 'Устарело! Используйте Country!',
		warning_en: 'Deprecated! Use Country!',
		old: 1,
	},
	{
		title: 'CountryRequest',
		decription: 'Возвращает подробную информацию о стране и список стран',
		decription_en: 'Returns detailed information about country and countries list',
		standart: false,
		errorResponse: 1,
		id: 'Country'
	},
	{
		title: 'CurrencyListRequest',
		decription: 'Возвращает список доступных валют',
		decription_en: 'Returns the list of available currencies',
		standart: true,
		errorResponse: 1,
		id: 'CurrencyList'
	},
	{
		title: 'CustomerRequest',
		decription: 'Возвращает список покупателей в счете-фактуре',
		decription_en: 'Returns the list of available Customers',
		standart: false,
		errorResponse: 2,
		id: 'Customer'
	},
	{
		title: 'ErrorRequest',
		decription: 'Возвращает список ошибок',
		decription_en: 'Returns the list of error',
		standart: true,
		errorResponse: 2,
		id: 'Error'
	},
	{
		title: 'ErrorTypeRequest',
		decription: 'Возвращает список типов ошибок',
		decription_en: 'Returns the list of error\'s types',
		standart: true,
		errorResponse: 2,
		id: 'ErrorType'
	},
	{
		title: 'GroupAccessRequest',
		decription: 'Возвращает список прав доступа к группам',
		decription_en: 'Returns the list of access rights to groups',
		standart: true,
		errorResponse: 1,
		id: 'GroupAccess'
	},
	{
		title: 'GroupCriterionTypeRequest',
		decription: 'Возвращает классификатор критериев групп',
		decription_en: 'Returns the classifier criteria for groups',
		standart: true,
		errorResponse: 1,
		id: 'GroupCriterionType'
	},
	{
		title: 'GuaranteeRequest',
		decription: 'Возвращает список видов предоплат/гарантий',
		decription_en: 'Returns the list of types of prepayment/guarantee',
		standart: true,
		errorResponse: 2,
		id: 'Guarantee'
	},
	{
		title: 'HotelAmenityListRequest',
		decription: 'Возвращает список характеристик гостиниц',
		decription_en: 'Returns the list of hotel amenities',
		standart: false,
		errorResponse: 1,
		id: 'HotelAmenityList',
		old: 1
	},
	{
		title: 'HotelDescriptionRequest',
		decription: 'Возвращает подробную информацию о конкретной гостинице',
		decription_en: 'Returns the detailed description of the selected hotel',
		standart: false,
		id: 'HotelDescription',
		warning: 'Устарело! Используйте Hotel!',
		warning_en: 'Deprecated! Use Hotel!',
		old: 1,
	},
	{
		title: 'HotelListRequest',
		decription: 'Возвращает список предлагаемых к продаже гостиниц',
		decription_en: 'Returns the list of hotels to sell',
		standart: false,
		errorResponse: 1,
		id: 'HotelList',
		warning: 'Устарело! Используйте Hotel!',
		warning_en: 'Deprecated! Use Hotel!',
		old: 1,
	},
	{
		title: 'HotelPricingRequest',
		decription: 'Возвращает рассчитанную стоимость проживания в гостинице.',
		decription_en: 'Returns the calculated price of the accommodation',
		standart: false,
		id: 'HotelPricing',
		warning: 'Устарело! Используйте HotelPricing2!',
		warning_en: 'Deprecated! Use HotelPricing2 instead!',
		old: 2,
	},
	{
		title: 'HotelPricingRequest2',
		decription: 'Возвращает рассчитанную стоимость проживания в гостинице в соответствии с	указанным планом размещения',
		decription_en: 'Returns the calculated price of the accommodation for the specified accommodation plan',
		standart: false,
		errorResponse: 1,
		id: 'HotelPricing2'
	},
	{
		title: 'HotelProductRequest',
		decription: 'Возвращает рассчитанную стоимость проживания в гостинице',
		decription_en: 'Returns the calculated price of the accommodation',
		standart: true,
		errorResponse: 1,
		id: 'HotelProduct'
	},
	{
		title: 'HotelRatingListRequest',
		decription: 'Возвращает список рангов гостиниц',
		decription_en: 'Returns the list of hotel ranks',
		standart: false,
		id: 'HotelRatingList',
		warning: 'Устарело! Используйте StarList!',
		warning_en: 'Deprecated! Use StarList instead!',
		old: 1,
	},
	{
		title: 'HotelRequest',
		decription: 'Возвращает подробную информацию о гостинице и список гостиниц',
		decription_en: 'Returns detailed information about hotel and hotels list',
		standart: false,
		errorResponse: 1,
		id: 'Hotel'
	},
	{
		title: 'HotelSearchRequest',
		decription: 'Возвращает список турпродуктов, соответствующих заданным критериям',
		decription_en: 'Returns the list of tour products which meet the specified criteria',
		standart: false,
		errorResponse: 1,
		id: 'HotelSearch'
	},
	{
		title: 'MealRequest',
		decription: 'Возвращает список питания',
		decription_en: 'Returns the list of meal',
		standart: true,
		errorResponse: 1,
		id: 'Meal'
	},
	{
		title: 'MealTypeRequest',
		decription: 'Возвращает список типов питания',
		decription_en: 'Returns the list of meal types',
		standart: true,
		errorResponse: 1,
		id: 'MealType'
	},
	{
		title: 'ObjectRequest',
		decription: 'Возвращает список объектов',
		decription_en: 'Returns the list of objects',
		standart: true,
		errorResponse: 2,
		id: 'Object'
	},
	{
		title: 'ObjectSubTypeRequest',
		decription: 'Возвращает список подтипов объектов',
		decription_en: 'Returns the list of object\'s subtypes',
		standart: true,
		errorResponse: 2,
		id: 'ObjectSubType'
	},
	{
		title: 'ObjectTypeRequest',
		decription: 'Возвращает список типов объектов',
		decription_en: 'Returns the list of object\'s types',
		standart: true,
		errorResponse: 2,
		id: 'ObjectType'
	},
	{
		title: 'ObjTypeListRequest',
		decription: 'Список типов объектов размещения',
		decription_en: 'List of types accommodation object',
		standart: true,
		errorResponse: 2,
		id: 'ObjTypeList'
	},
	{
		title: 'OrderDocsRequest',
		decription: 'Позволяет получить документы по заказу',
		decription_en: 'Allows to get reservation documents on request',
		standart: false,
		errorResponse: 1,
		id: 'OrderDocs'
	},
	{
		title: 'OrderInfoNotifyRequest',
		decription: 'Информирует компьютерную систему покупателя об изменении в заказе',
		decription_en: 'Notify buyer\'s computer system about changes in orders',
		standart: false,
		errorResponse: 1,
		id: 'OrderInfoNotify'
	},
	{
		title: 'OrderInfoRequest',
		decription: 'Возвращает информацию о заказе',
		decription_en: 'Returns the order\'s details',
		standart: false,
		errorResponse: 1,
		id: 'OrderInfo'
	},
	{
		title: 'OrderListRequest',
		decription: 'Возвращает список заказов, соответствующих заданным критериям',
		decription_en: 'Returns the list of orders which meet the specified criteria',
		standart: true,
		errorResponse: 1,
		id: 'OrderList'
	},
	{
		title: 'OrderRequest',
		decription: 'Создает, изменяет и аннулирует заказ',
		decription_en: 'Create, amend or cancel an order',
		standart: false,
		errorResponse: 1,
		id: 'Order'
	},
	{
		title: 'RateGroupRequest',
		decription: 'Возвращает список групп тарифов',
		decription_en: 'Returns the list of group of rates',
		standart: true,
		errorResponse: 1,
		id: 'RateGroup'
	},
	{
		title: 'PenaltyReasonRequest',
		decription: 'Возвращает список причин штрафа',
		decription_en: 'Returns the list of penalty reasons',
		standart: true,
		errorResponse: 1,
		id: 'PenaltyReason'
	},
	{
		title: 'ServiceListRequest',
		decription: 'Возвращает список услуг, соответствующих заданным критериям',
		decription_en: 'Returns the list of services which meet the specified criteria',
		standart: false,
		errorResponse: 1,
		id: 'ServiceList'
	},
	{
		title: 'ServiceTypeRequest',
		decription: 'Выдаёт доступные типы услуг в продаже',
		decription_en: 'Returns available types of services for sale',
		standart: true,
		errorResponse: 1,
		id: 'ServiceType'
	},
	{
		title: 'SpecialOfferTypeRequest',
		decription: 'Возвращает список типов акций',
		decription_en: 'Returns the list of type of action',
		standart: true,
		errorResponse: 2,
		id: 'SpecialOfferType'
	},
	{
		title: 'SpecialRequirementTypeRequest',
		decription: 'Возвращает список типов особых условий бронирования гостиниц',
		decription_en: 'Returns the list types of special requirement',
		standart: true,
		errorResponse: 2,
		id: 'SpecialRequirementType'
	},
	{
		title: 'StarListRequest',
		decription: 'Возвращает список категорий гостиниц',
		decription_en: 'Returns the list of hotel categories',
		standart: true,
		errorResponse: 1,
		id: 'StarList'
	},
	{
		title: 'StatusListRequest',
		decription: 'Возвращает список технологических статусов услуги',
		decription_en: 'Returns the list of technological statuses services',
		standart: true,
		errorResponse: 2,
		id: 'StatusList'
	},
	{
		title: 'TypeOfPlaceRequest',
		decription: 'Возвращает список типов населенных пунктов',
		decription_en: 'Returns the list of settlements type',
		standart: true,
		errorResponse: 2,
		id: 'TypeOfPlace'
	},
	{
		title: 'UserGroupRequest',
		decription: 'Возвращает список групп пользователей',
		decription_en: 'Returns the list of user groups',
		standart: false,
		errorResponse: 1,
		id: 'UserGroup'
	},
	{
		title: 'UserPrivilegeRequest',
		decription: 'Возвращает список привилегий пользователей',
		decription_en: 'Returns the list of user privileges',
		standart: true,
		errorResponse: 1,
		id: 'UserPrivilege'
	},
	{
		title: 'UsersRequest',
		decription: 'Возвращает список пользователей',
		decription_en: 'Returns the list of users',
		standart: false,
		errorResponse: 1,
		id: 'Users'
	},
	{
		title: 'VagentGroupTypeRequest',
		decription: 'Возвращает список групп компаний',
		decription_en: 'Return the companies groups list',
		standart: true,
		errorResponse: 0,
		id: 'VagentGroupType'
	},
	{
		title: 'VATRateRequest',
		decription: 'Возвращает доступные типы НДС для страны',
		decription_en: 'Returns available VAT types for country',
		standart: true,
		errorResponse: 1,
		id: 'VATRate'
	},
	{
		title: 'WhereToPayRequest',
		decription: 'Возвращает список мест оплаты',
		decription_en: 'Returns the list of payment place',
		standart: true,
		errorResponse: 2,
		id: 'WhereToPay'
	},
	{
		title: 'VIPStatusRequest',
		decription: 'Возвращает VIP-статусы клиентов',
		decription_en: 'VIP-statuses for clients',
		standart: true,
		errorResponse: 0,
		id: 'VIPStatus'
	},
	{
		title: 'XMLAccessRequest',
		decription: 'Возвращает список XML-доступов',
		decription_en: 'Returns the list of XML-accesses',
		standart: true,
		errorResponse: 1,
		id: 'XMLAccess'
	},

];

export default methods;
